// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ChatFileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChatFileQuery = { __typename?: 'Query', chatFile: { __typename?: 'ChatFile', id: string, sessionId: string, messageId?: string | null, origin: Types.ChatFileOrigin, status: Types.ChatFileStatus, fileName: string, mimeType?: string | null, size?: number | null, width?: number | null, height?: number | null, failureCode?: string | null, operationId?: string | null, createdAt: any } };


export const ChatFileDocument = gql`
    query ChatFile($id: ID!) {
  chatFile(id: $id) {
    id
    sessionId
    messageId
    origin
    status
    fileName
    mimeType
    size
    width
    height
    failureCode
    operationId
    createdAt
  }
}
    `;

/**
 * __useChatFileQuery__
 *
 * To run a query within a React component, call `useChatFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatFileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatFileQuery, ChatFileQueryVariables> & ({ variables: ChatFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatFileQuery, ChatFileQueryVariables>(ChatFileDocument, options);
      }
export function useChatFileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatFileQuery, ChatFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatFileQuery, ChatFileQueryVariables>(ChatFileDocument, options);
        }
// @ts-ignore
export function useChatFileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatFileQuery, ChatFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatFileQuery, ChatFileQueryVariables>;
export function useChatFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatFileQuery, ChatFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatFileQuery | undefined, ChatFileQueryVariables>;
export function useChatFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatFileQuery, ChatFileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatFileQuery, ChatFileQueryVariables>(ChatFileDocument, options);
        }
export type ChatFileQueryHookResult = ReturnType<typeof useChatFileQuery>;
export type ChatFileLazyQueryHookResult = ReturnType<typeof useChatFileLazyQuery>;
export type ChatFileSuspenseQueryHookResult = ReturnType<typeof useChatFileSuspenseQuery>;
export type ChatFileQueryResult = ApolloReactCommon.QueryResult<ChatFileQuery, ChatFileQueryVariables>;